import { api } from '@/api';

export interface RolePermission {
  uuid: string;
  role: string;
  permission: string;
  role_name: string;
  permission_name: string;
  permission_description: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  is_deleted: boolean;
}

export interface UserPermission extends Record<string, unknown> {
  uuid: string;
  user: string;
  role_permission: RolePermission;
  permission_name: string;
  granted_at: string;
  granted_by: string | null;
  expires_at: string | null;
  is_active: boolean;
}

export interface UserPermissionsPagination {
  current_page: number;
  total_pages: number;
  total_items: number;
  page_size: number;
  has_next: boolean;
  has_previous: boolean;
  next_page: number | null;
  previous_page: number | null;
}

export interface UserPermissionsResponse {
  success: boolean;
  message: string;
  data: {
    user_permissions: UserPermission[];
    pagination: UserPermissionsPagination;
  };

  // Support actual API structure
  results?: UserPermission[];
  count?: number;
  next?: string | null;
  previous?: string | null;
}

export interface CreateUserPermissionPayload {
  user: string;
  role_permission: string;
}

export interface CreateUserPermissionResponse {
  success: boolean;
  message: string;
  data: {
    id?: string;
    user?: string;
    role_permission?: string;
  };
}

export const userPermissionsService = {
  async getUserPermissions(): Promise<UserPermissionsResponse> {
    const response = await api.get<UserPermissionsResponse>('/backoffice/api/v1/user-permissions/');
    return response as unknown as UserPermissionsResponse;
  },

  async createUserPermission(payload: CreateUserPermissionPayload): Promise<CreateUserPermissionResponse> {
    const response = await api.post<CreateUserPermissionResponse>('/backoffice/api/v1/user-permissions/', payload);
    return response as unknown as CreateUserPermissionResponse;
  },
};

export default userPermissionsService;
